/* eslint-disable react/forbid-prop-types */
import React, {useContext} from 'react'
import PropTypes from 'prop-types'
import {SelectPure, selectComponents, InputContainer} from '@modifi/ui'
import {FormDataContext, FormInput} from '@modifi/plugin-forms'
import {useTranslation} from '@modifi/plugin-i18n'

import {StyledTwemoji, StyledSingleValue, OptionWrapper} from './styles'
import {RequiredLabel} from '../../styles'

const {Option: DefaultOption} = selectComponents

const Option = ({data, ...restProps}) => {
  const {countryName, phonePrefix, flag} = data
  return (
    <DefaultOption {...restProps} data={data}>
      <OptionWrapper>
        <StyledTwemoji
          options={{base: 'https://cdn.jsdelivr.net/gh/twitter/twemoji@14.0.2/assets/'}}
        >
          {flag}
        </StyledTwemoji>{' '}
        {phonePrefix} {countryName}
      </OptionWrapper>
    </DefaultOption>
  )
}

Option.propTypes = {
  innerProps: PropTypes.object.isRequired,
  isFocused: PropTypes.bool.isRequired,
  isSelected: PropTypes.bool.isRequired,
  data: PropTypes.shape({
    countryName: PropTypes.string,
    phonePrefix: PropTypes.string,
    flag: PropTypes.string,
  }).isRequired,
}

const SingleValue = ({innerProps, data: {flag, phonePrefix}}) => (
  <StyledSingleValue {...innerProps}>
    <StyledTwemoji options={{base: 'https://cdn.jsdelivr.net/gh/twitter/twemoji@14.0.2/assets/'}}>
      {flag}
    </StyledTwemoji>{' '}
    {phonePrefix}
  </StyledSingleValue>
)

SingleValue.propTypes = {
  innerProps: PropTypes.object,
  data: PropTypes.shape({
    phonePrefix: PropTypes.string,
    flag: PropTypes.string,
  }).isRequired,
}

SingleValue.defaultProps = {
  innerProps: {},
}

const CountryCodeSelect = props => <SelectPure components={{Option, SingleValue}} {...props} />

const CountryCodeSelectWithContainer = props => (
  <InputContainer inputComponent={CountryCodeSelect} {...props} />
)

const CountryCodeSelectInput = ({countryCodeOptions, janusTrans}) => {
  const {t} = useTranslation('pkg:forms')
  const {changeData, data} = useContext(FormDataContext)

  const handleChange = updatedData => {
    if (!data?.country) {
      changeData('country', updatedData?.value)
    }
  }
  return (
    <FormInput
      name="countryCode"
      t={t}
      inputComponent={CountryCodeSelectWithContainer}
      label={<RequiredLabel>{janusTrans('signup.country-code.label')}</RequiredLabel>}
      placeholder={janusTrans('signup.country-code.placeholder')}
      options={countryCodeOptions}
      oneOf={countryCodeOptions.map(({value}) => value)}
      oneOfMessage="tr:phone-prefix.error.one-of"
      noBlur
      onChange={handleChange}
    />
  )
}

CountryCodeSelectInput.propTypes = {
  countryCodeOptions: PropTypes.arrayOf(
    PropTypes.shape({
      flag: PropTypes.string,
      phonePrefix: PropTypes.string,
      countryName: PropTypes.string,
      label: PropTypes.string,
      value: PropTypes.string,
    })
  ).isRequired,
  janusTrans: PropTypes.func.isRequired,
}

export default CountryCodeSelectInput
